const indexItems = [
  { title: '2026年7月最新爆料合集', desc: '本月最全911吃瓜黑料事件汇总，从月初到月末完整时间线。', tag: '月度合集', count: '47篇' },
  { title: '娱乐圈明星人设崩塌全记录', desc: '细数那些在公众面前维持人设却最终翻车的艺人故事合集。', tag: '人设崩塌', count: '23篇' },
  { title: '网红直播带货翻车经典案例', desc: '从产品质量到售后纠纷，直播带货翻车事件深度盘点。', tag: '直播翻车', count: '35篇' },
  { title: '互联网大厂内部文化揭秘系列', desc: '多家知名互联网公司内部工作环境与文化氛围真实揭秘。', tag: '大厂揭秘', count: '18篇' },
  { title: '热门综艺节目台前幕后全知道', desc: '当红综艺节目的录制内幕、选手故事与制作细节大公开。', tag: '综艺揭秘', count: '29篇' },
  { title: '娱乐圈法律纠纷案件深度解读', desc: '从合同争议到名誉侵权，涉及娱乐圈的法律案件专业解读。', tag: '法律解读', count: '15篇' },
  { title: '年度十大反转爆料事件回顾', desc: '那些最初被认定的事实最终反转的惊人事件完整时间线。', tag: '事件反转', count: '10篇' },
  { title: '社交平台舆论操控技术深度分析', desc: '从水军到算法，揭示社交媒体上舆论操控的完整技术链条。', tag: '舆论分析', count: '12篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              主题<span className="text-primary-500">索引</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              精选911吃瓜黑料合集，按主题快速定位你感兴趣的内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-5 hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="px-2.5 py-1 text-xs font-bold bg-accent-100 text-accent-700 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}